import React, { useState, useEffect } from "react";
import { FiDownload, FiArrowDown } from "react-icons/fi";
import { FaGithub, FaLinkedinIn, FaCode } from "react-icons/fa";
import "./Hero.css";

const Hero = () => {
  const [displayText, setDisplayText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const roles = [
      "Frontend Developer",
      "Creative Thinker",
      "Software Developer",
      "Problem Solver",
    ];
    
    const currentRole = roles[currentIndex];
    let timeout;

    if (!isDeleting) {
      if (displayText.length < currentRole.length) {
        timeout = setTimeout(() => {
          setDisplayText(currentRole.slice(0, displayText.length + 1));
        }, 100);
      } else {
        timeout = setTimeout(() => {
          setIsDeleting(true);
        }, 2000);
      }
    } else {
      if (displayText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayText(currentRole.slice(0, displayText.length - 1));
        }, 50);
      } else {
        setIsDeleting(false);
        setCurrentIndex((prev) => (prev + 1) % roles.length);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayText, currentIndex, isDeleting]);

  const scrollToPortfolio = () => {
    document
      .getElementById("portfolio")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="hero">
      <div className="hero-bg">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="hero-grid"></div>
      </div>

      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge fade-in">
            <span className="badge-dot"></span>
            <span>Available for Hire</span>
          </div>

          <h1 className="hero-title fade-in delay-1">
            Hi, I'm <span className="gradient-text">Divyansh</span>
            <br />
            <span className="hero-role">
              {displayText}
              <span className="cursor">|</span>
            </span>
          </h1>

          <p className="hero-description fade-in delay-2">
            I craft from idea to deployment, I build products that scale. Code.
            Create. Innovate.
          </p>

          <div className="hero-cta fade-in delay-3">
            <button onClick={scrollToPortfolio} className="btn btn-primary">
              View My Work
              <FiArrowDown />
            </button>
            <a
              href="https://drive.google.com/file/d/17FGUKIip9Erxev0Pz4MaNZslzCOR7uC9/view?usp=sharing"
              download
              className="btn btn-secondary"
            >
              <FiDownload />
              Download Resume
            </a>
          </div>

          <div className="hero-social fade-in delay-4">
            <span className="social-label">Follow me</span>
            <div className="social-links">
              <a
                href="https://github.com/theDivyansh"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="GitHub"
              >
                <FaGithub />
              </a>
              <a
                href="https://www.linkedin.com/in/divyansh-gupta-b9a435249/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://leetcode.com/u/the_Divyansh01/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LeetCode"
              >
                <FaCode />
              </a>
            </div>
          </div>
        </div>

        <div className="hero-image fade-in delay-2">
          <div className="hero-image-wrapper">
            <div className="hero-image-bg"></div>
            <div className="hero-avatar">
              <img src="/assets/Profile_image.JPG" alt="Divyansh - Developer" />
            </div>
          </div>
        </div>
      </div>

      <div className="scroll-indicator fade-in delay-5">
        <span>Scroll</span>
        <div className="scroll-line">
          <div className="scroll-dot"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
